import React from 'react';
import { FaMoneyBillWave, FaPhoneAlt, FaLaptopCode, FaShieldAlt } from 'react-icons/fa';
import CardsSection from '../../components/CardsSection/CardsSection';

const benefitItems = [
  {
    icon: <FaMoneyBillWave />,
    title: '100% Geld zurück Garantie',
    description: 'Wenn Sie nicht zufrieden sind, erhalten Sie Ihr Geld vollständig zurück.'
  },
  {
    icon: <FaPhoneAlt />,
    title: 'Kostenloses Erstgespräch',
    description: 'Erhalten Sie eine unverbindliche Beratung, um Ihre Bedürfnisse zu besprechen.'
  },
  {
    icon: <FaLaptopCode />,
    title: 'Maßgeschneiderte Lösungen',
    description: 'Individuelle und skalierbare Lösungen, perfekt auf Ihre Geschäftsanforderungen zugeschnitten.'
  },
  {
    icon: <FaShieldAlt />,
    title: 'Sicherheit & Datenschutz',
    description: 'Höchste Sicherheitsstandards schützen Ihre Daten und gewährleisten Vertrauen.'
  }
];

const OurBenefitsSection = () => {
  return (
    <CardsSection 
      title="Unsere Vorteile"
      items={benefitItems}
      sectionClass="benefits-section" /* Optional: extra class names for styling */
    />
  );
};

export default OurBenefitsSection;
